import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './Carousel.css';

import img1 from '../../assets/WechatIMG7.jpg';
import img2 from '../../assets/WechatIMG8.jpg';
import img3 from '../../assets/WechatIMG9.jpg';
import img4 from '../../assets/WechatIMG10.jpg';

function Carousel() {
  return (
    <div className="carouselContainer">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        className="carousel"
      >
        <SwiperSlide>
          <img src={img1} alt="Slide 1" className="carouselImage" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={img2} alt="Slide 2" className="carouselImage" />
          {}
        </SwiperSlide>
        <SwiperSlide>
          <img src={img3} alt="Slide 3" className="carouselImage" />
          {}
        </SwiperSlide>
        <SwiperSlide>
          <img src={img4} alt="Slide 4" className="carouselImage" />
          {}
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default Carousel;